import React, { useState, useEffect } from 'react';
import CategoryHosts from './CategoryHosts';
import CategoryInfo from './CategoryInfo';
import CategorySchedules from './CategorySchedules';

const CategoryDetailLeft = ({ isCreating }) => {
  const [schedulesRootCategory, setSchedulesRootCategory] = useState([]);

  return (
    <>
      <CategoryInfo isCreating={isCreating} setSchedulesRootCategory={setSchedulesRootCategory} />

      {!isCreating && (
        <>
          <CategorySchedules schedulesRootCategory={schedulesRootCategory} />
          <CategoryHosts />
        </>
      )}
    </>
  );
};

export default CategoryDetailLeft;
